// extracted by mini-css-extract-plugin
export default {"arrangements":"Arrangements_arrangements__rf3uh","arrangements__content":"Arrangements_arrangements__content__9Wiaq"};